export default {
  APP_DISPLAYER: 'auth.app.display',
  APP_CREATOR: 'auth.app.create',
  APP_EDITOR: 'auth.app.edit',
  SDK_CREATOR: 'auth.sdk.create',
  APP_AUDIT: 'backend.app.audit',
  PRIVATE_AUDIT: 'backend.private.audit',
  SDK_AUDIT: 'backend.sdk.audit',
  YOUTUBOX_AUDIT: 'backend.youtubox.audit',

  OPEN_HOME: 'open.home',
  OPEN_APP: 'open.app',
  OPEN_APP_DISPLAY: 'open.app.display',
  OPEN_APP_CREATOR: 'open.app.create',
  OPEN_PRIVATE_DISPLAY: 'open.private.display',
  OPEN_PRIVATE_CREATOR: 'open.private.create',
  OPEN_YOUTU_BOX_DISPLAY: 'open.box.display',
  OPEN_YOUTU_BOX_CREATOR: 'open.ceta.create',
  OPEN_SDK_DISPLAY: 'open.sdk.display',
  OPEN_SDK_CREATOR: 'open.sdk.create',
  OPEN_FACE_MERGE: 'open.face.merge',
  OPEN_APP_MESSAGE: 'open.app.message',

  OPEN_ABOUTUS_INTRO: 'open.aboutus.intro',
  OPEN_ABOUTUS_NEWS: 'open.aboutus.news',
  OPEN_ABOUTUS_PUBLICATIONS: 'open.aboutus.publications',
  OPEN_ABOUTUS_PARTNER: 'open.aboutus.partner',
  OPEN_ABOUTUS_CONTACTUS: 'open.aboutus.contactus',

  OPEN_VERIFY_PHONE: 'open.validate.phone',
  OPEN_VERIFY_MAIL: 'open.validate.mail',
  OPEN_ACTIVE_MAIL: 'oen.validate.active',
  OPEN_VERIFY_SUCCESS: 'open.validate.success',
  OPEN_VERIFY_FAIL: 'open.validate.fail',

  OPEN_SOLUTION_INVOICE: 'open.solution.invoice',
  OPEN_SOLUTION_FACEIN: 'open.solution.facein',
  OPEN_SOLUTION_AUDITING: 'open.solution.auditing',
  OPEN_SOLUTION_BROADCAST: 'open.solution.broadcast',
  OPEN_SOLUTION_VIDEO_UNDERSTAND: 'videounderstand',
  OPEN_SOLUTION_FACEIN_FW: 'faceinfw',
  OPEN_SOLUTION_ADULT: 'adult',
  OPEN_SOLUTION_FORGERY: 'forgery',
  OPEN_SOLUTION_TIM: 'tim',
  OPEN_SOLUTION_EDUCATION: 'open.solution.education',
  OPEN_SOLUTION_INSURANCE: 'open.solution.insurance',
  OPEN_SOLUTION_SDKPRODUCTION: 'open.solution.sdkproduction',
  OPEN_COOPERATION: 'open.cooperation',
  OPEN_NEWSCENTER: 'open.news',
  OPEN_NEWS_1: 'open.news.1',
  OPEN_NEWS_2: 'open.news.2',
  OPEN_NEWS_3: 'open.news.3',
  OPEN_NEWS_4: 'open.news.4',
  OPEN_NEWS_5: 'open.news.5',
  OPEN_NEWS_6: 'open.news.6',
  OPEN_NEWS_7: 'open.news.7',
  OPEN_NEWS_8: 'open.news.8',
  OPEN_NEWS_9: 'open.news.9',
  OPEN_NEWS_10: 'open.news.10',
  OPEN_NEWS_11: 'open.news.11',
  OPEN_NEWS_12: 'open.news.12',
  OPEN_NEWS_13: 'open.news.13',
  OPEN_NEWS_14: 'open.news.14',
  OPEN_NEWS_15: 'open.news.15',
  OPEN_NEWS_16: 'open.news.16',
  OPEN_NEWS_17: 'open.news.17',
  OPEN_NEWS_18: 'open.news.18',
  OPEN_NEWS_19: 'open.news.19',
  OPEN_NEWS_20: 'open.news.20',
  OPEN_NEWS_21: 'open.news.21',
  OPEN_NEWS_22: 'open.news.22',
  OPEN_NEWS_23: 'open.news.23',
  OPEN_NEWS_24: 'open.news.24',
  OPEN_NEWS_25: 'open.news.25',
  OPEN_NEWS_26: 'open.news.26',
  OPEN_NEWS_27: 'open.news.27',
  OPEN_NEWS_28: 'open.news.28',
  OPEN_NEWS_29: 'open.news.29',
  OPEN_NEWS_30: 'open.news.30',
  OPEN_NEWS_31: 'open.news.31',
  OPEN_NEWS_32: 'open.news.32',
  OPEN_NEWS_33: 'open.news.33',
  OPEN_NEWS_34: 'open.news.34',
  OPEN_NEWS_35: 'open.news.35',
  OPEN_NEWS_36: 'open.news.36',
  OPEN_NEWS_37: 'open.news.37',
  OPEN_NEWS_38: 'open.news.38',
  OPEN_NEWS_39: 'open.news.39',
  OPEN_NEWS_40: 'open.news.40',
  OPEN_NEWS_41: 'open.news.41',
  OPEN_NEWS_42: 'open.news.42',
  OPEN_NEWS_43: 'open.news.43',
  OPEN_NEWS_44: 'open.news.44',
  OPEN_NEWS_45: 'open.news.45',
  OPEN_NEWS_46: 'open.news.46',
  OPEN_NEWS_47: 'open.news.47',
  OPEN_NEWS_48: 'open.news.48',
  OPEN_NEWS_49: 'open.news.49',
  OPEN_NEWS_50: 'open.news.50',
  OPEN_NEWS_51: 'open.news.51',
  OPEN_NEWS_52: 'open.news.52',
  OPEN_NEWS_53: 'open.news.53',
  OPEN_NEWS_54: 'open.news.54',
  OPEN_NEWS_55: 'open.news.55',
  OPEN_NEWS_56: 'open.news.56',
  OPEN_NEWS_57: 'open.news.57',
  OPEN_NEWS_58: 'open.news.58',
  OPEN_NEWS_59: 'open.news.59',
  OPEN_NEWS_60: 'open.news.60',
  OPEN_NEWS_61: 'open.news.61',
  OPEN_NEWS_62: 'open.news.62',
  OPEN_NEWS_63: 'open.news.63',
  OPEN_NEWS_64: 'open.news.64',
  OPEN_NEWS_65: 'open.news.65',
  OPEN_NEWS_66: 'open.news.66',
  OPEN_NEWS_67: 'open.news.67',
  OPEN_NEWS_68: 'open.news.68',
  OPEN_NEWS_69: 'open.news.69',
  OPEN_NEWS_70: 'open.news.70',
  OPEN_NEWS_71: 'open.news.71',
  OPEN_NEWS_72: 'open.news.72',
  OPEN_NEWS_73: 'open.news.73',
  OPEN_NEWS_74: 'open.news.74',
  OPEN_NEWS_75: 'open.news.75',
  OPEN_NEWS_76: 'open.news.76',
  OPEN_NEWS_77: 'open.news.77',
  OPEN_NEWS_78: 'open.news.78',
  OPEN_NEWS_79: 'open.news.79',
  OPEN_NEWS_80: 'open.news.80',
  OPEN_NEWS_81: 'open.news.81',
  OPEN_NEWS_82: 'open.news.82',

  OPEN_ACADEMIC_RESEARCH: 'open.academic',

  Article: 'introduce'
};



// WEBPACK FOOTER //
// ./src/common/RouteKey.js